export const HOUR_h_MINUTE_m_SECONDS_s_FORMAT = "HH'h' mm'm' ss's'"
export const MINUTE_m_SECONDS_s_FORMAT = "mm 'mins. and' ss ' secs.'"
export const DURATION_FORMAT = "hh'h' mm'm' ss's'"
export const DURATION_WITH_PLUS_PREFIX_FORMAT = '+ ' + DURATION_FORMAT
export const ONLY_YEAR_FORMAT = 'yyyy'
export const SHORT_MONTH_AND_YEAR_FORMAT = 'MMM yyyy'
export const MONTH_DAY_AND_YEAR_FORMAT = 'MMM dd yyyy'
